import { useState } from 'react';
import { AddDomainRequest, Domain, VerifyDomainRequest, DeleteDomainRequest } from 'vopay';
import { api } from '@/services/api.config';

export default function useEmailDomain() {
  const [fetching, setFetching] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [domain, setDomain] = useState<Domain | null>(null);

  async function fetchDomain() {
    try {
      setFetching(true);
      const res = await api.fetchDomain();
      if (!res.Success) throw new Error(res.ErrorMessage);
      setDomain(res.Domain);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  async function addDomain(params: AddDomainRequest) {
    try {
      const res = await api.addDomain(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async function verifyDomain(params: VerifyDomainRequest) {
    try {
      setVerifying(true);
      const res = await api.verifyDomain(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setVerifying(false);
    }
  }

  async function deleteDomain(params: DeleteDomainRequest) {
    try {
      setDeleting(true);
      const res = await api.deleteDomain(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setDeleting(false);
    }
  }

  return {
    fetching,
    verifying,
    deleting,
    domain,
    setDomain,
    fetchDomain,
    addDomain,
    verifyDomain,
    deleteDomain,
  };
}
